import IssuesAPI from '../../api/issues';

export const SET_ISSUE_MEMBERS_UI_FLAG = 'SET_ISSUE_MEMBERS_UI_FLAG';
export const ADD_AGENTS_TO_ISSUE = 'ADD_AGENTS_TO_ISSUE';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getIssueMembers: $state => id => {
    return $state.records[id] || [];
  },
};

export const actions = {
  get: async ({ commit }, { issueId }) => {
    commit(SET_ISSUE_MEMBERS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await IssuesAPI.getAgents({ issueId });
      commit(ADD_AGENTS_TO_ISSUE, { data, issueId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_MEMBERS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, { agentsList, issueId }) => {
    commit(SET_ISSUE_MEMBERS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await IssuesAPI.addAgents({ agentsList, issueId });
      commit(ADD_AGENTS_TO_ISSUE, { issueId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_MEMBERS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { agentsList, issueId }) => {
    commit(SET_ISSUE_MEMBERS_UI_FLAG, { isUpdating: true });
    try {
      const response = await IssuesAPI.updateAgents({
        agentsList,
        issueId,
      });
      commit(ADD_AGENTS_TO_ISSUE, response);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_MEMBERS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [SET_ISSUE_MEMBERS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [ADD_AGENTS_TO_ISSUE]($state, { data, issueId }) {
    $state.records = {
      ...$state.records,
      [issueId]: data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
